import { NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
	CategoryLinkPipe,
	CategoryNamePipe,
	CdnPathPipe,
	EntitiesPipe,
	HelperService,
	TruncatePipe,
	UcDatePipe,
} from '@uc/utilities';

@Component({
	selector: 'uc-advice-article-card',
	templateUrl: './advice-article-card.component.html',
	imports: [
		RouterModule,
		NgStyle,
		CdnPathPipe,
		CategoryLinkPipe,
		CategoryNamePipe,
		EntitiesPipe,
		UcDatePipe,
		TruncatePipe,
	],
})
export class AdviceArticleCardComponent implements OnInit {
	@Input() article: any;
	urlParts!: string[];
	private _categoryLink = new CategoryLinkPipe();

	constructor(private _helper: HelperService) {}

	ngOnInit(): void {
		//to ensure forward slashes are not encoded by routerLink

		// when PHP returns url as 'advice/category/articleUrl'
		if (this.article.url.includes('advice/')) {
			this.urlParts = this._helper.splitUrlIntoParts(this.article.url);

			// when PHP returns url as 'articleUrl'
		} else {
			const category = this._categoryLink.transform(
				this.article.cat_name,
				'advice',
			);
			this.urlParts = ['/advice/', category, this.article.url];
		}

		/* TODO: ask backend guys to standardise the url */
	}
}
